import { Button, Typography } from '@mui/material';

/**
 * LDS Button 컴포넌트
 * @param variant optional, default: 'contained'
 * @param onClick
 * @param title
 * @param color optional, default: 'primary'
 *
 * @deprecated stories 폴더의 LookoButton 사용
 */
export default function LookoButton({
  variant = 'contained',
  onClick,
  title,
  color = 'primary',
  heigth = 'md',
  width = 'md',
  disabled,
}: {
  variant?: 'text' | 'outlined' | 'contained';
  onClick?: () => void;
  title?: React.ReactNode;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  heigth?: 'md' | 'lg';
  width?: 'md' | 'lg';
  disabled?: boolean;
}) {
  return (
    <Button
      disabled={disabled}
      variant={variant}
      sx={{ height: heigth === 'md' ? '32px' : '40px' }}
      color={color}
      onClick={onClick}
      fullWidth={width === 'lg' ? true : false}
    >
      <Typography variant={heigth === 'lg' ? 'Subtitle_Looko' : 'Body_Looko'}>{title}</Typography>
    </Button>
  );
}

/**
 * LDS Button(outlined) bgcolor='white' 컴포넌트
 * @param onClick
 * @param title
 * @param color optional, default: 'primary'
 *
 * @deprecated stories 폴더의 LookoButton 사용
 */
export function LookoOutlinedWhiteButton({
  variant = 'contained',
  onClick,
  title,
  color = 'primary',
  heigth = 'md',
  width = 'md',
  disabled = false,
}: {
  variant?: 'text' | 'outlined' | 'contained';
  onClick?: () => void;
  title?: React.ReactNode;
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  heigth?: 'md' | 'lg';
  width?: 'md' | 'lg';
  disabled?: boolean;
}) {
  return (
    <Button
      disabled={disabled}
      variant="outlined"
      sx={{ height: heigth === 'md' ? '32px' : '40px', bgcolor: 'white' }}
      color={color}
      onClick={onClick}
      fullWidth={width === 'lg' ? true : false}
    >
      <Typography variant="Subtitle_Looko">{title}</Typography>
    </Button>
  );
}
